package us.laantech.common.dto

import kotlinx.serialization.Serializable

@Serializable
data class InventoryDTO(
    val createdAt: Long?,
    val addedCount: Long? = 0,
    val unitCostCents: Long? = null,

    val soldCount: Long? = 0,

    val expiredCount: Long? = 0,
    val damagedCount: Long? = 0,
    val writeOffCount: Long? = 0,
    val storeUseCount: Long? = 0,
    val lostCount: Long? = 0,
){

    val total: Long get() = (addedCount ?: 0) - (soldCount ?: 0) - (expiredCount ?: 0) - (damagedCount ?: 0) - (writeOffCount ?: 0) - (storeUseCount ?: 0) - (lostCount ?: 0)

}